<template>
  <div class="users-actions">
    <div class="listing-title">{{ $t('users.listing.actions.title') }}</div>
    <div class="spacer" />
    <div class="search">
      <TolTypeAhead
        :search-params="{
          url: `/users/list?activeInactive=${activeInactive}&sortBy=${sortBy}
              &sortDirection=${sortDirection}&recordsPerPage=${recordsPerPage}&offset=${offSet}`,
          searchKeys: ['searchParam']
        }"
        :results-in-dropdown="false"
        :allow-empty-search="true"
        @filtered="onFiltered($event)"
      />
    </div>
    <div class="export">
      <TolAltButton
        v-click-outside="() => (showDropdown = false)"
        icon-name="file-excel"
        label="Export to Excel"
        @click="showDropdown = !showDropdown"
      />

      <Dropdown
        v-show="showDropdown"
        :menu-items="[{ label: 'Export All' }, { label: 'Export this page' }]"
        class="dropdown-menu-right"
        @optionClicked="onExportChange($event)"
      />
    </div>
  </div>
</template>

<script>
import TolAltButton from '@/app/components/TolAltButton';
import Dropdown from '@/app/components/Dropdown';
import { UsersListingActions } from '../users-listing-keys';
import vClickOutside from 'v-click-outside';
import TolTypeAhead from '../../../../components/TolTypeAhead';
import { UsersListingGetters } from '../../users-listing/users-listing-keys';
export default {
  components: {
    TolAltButton,
    Dropdown,
    TolTypeAhead
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      showDropdown: false
    };
  },
  computed: {
    activeInactive() {
      return this.$store.getters[UsersListingGetters.UsersActiveInactive];
    },
    sortBy() {
      return this.$store.getters[UsersListingGetters.SortBy];
    },
    sortDirection() {
      return this.$store.getters[UsersListingGetters.SortDirection];
    },
    recordsPerPage() {
      return this.$store.getters[UsersListingGetters.UsersPerPage];
    },
    offSet() {
      return this.$store.getters[UsersListingGetters.UsersListingOffset];
    }
  },
  methods: {
    onExportChange(event) {
      if (event.menuOption === 'Export All') {
        this.$store.dispatch(UsersListingActions.ExportAllUsers);
      } else {
        this.$store.dispatch(UsersListingActions.ExportThisPage);
      }
    },
    onFiltered(results) {
      results.data.map(users => {
        users.name = users.last_name + ', ' + users.first_name;
      });
      this.$store.dispatch(UsersListingActions.UpddateSearchList, results);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../styles/colors.scss';
@import '../../../../styles/variables.scss';

.users-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;

  .spacer {
    flex-grow: 1;
  }

  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
    flex-basis: 25%;
  }

  .export {
    display: flex;
    position: relative;
    justify-content: flex-end;
    flex-basis: 25%;
  }

  .search {
    display: flex;
    flex-basis: 50%;
    .search-container {
      flex: 1;
    }
  }
}
</style>
